import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
//import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {ActivatedRoute, NavigationExtras, ParamMap, Router} from "@angular/router";
import {RegisterService} from "../services/register.service";
import {environment} from "../environments/environment";
import {CustomDatePipe} from "../shared/custom.datepipe";
import {UUID} from "angular2-uuid";
import {Md5} from "ts-md5";
import {DeviceDetectorService} from "ngx-device-detector";
//import {Channel} from "../channel";
//import {ChannelService} from "../channel.service";
import {Unsub} from "../modl/unsub";
import {NgIf} from "@angular/common";

//import 'bootstrap/dist/js/bootstrap.bundle.min';
//import 'bootstrap/dist/css/bootstrap.min.css';
//import 'jquery/dist/jquery.min.js';
//import 'popper.js/dist/popper.min';
//import 'bootstrap/dist/js/bootstrap.min';

@Component({
  selector: 'app-cancel',
  templateUrl: './unsubscribe.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf
  ],
  styleUrls: ['./unsubscribe.component.css']
})
export class UnsubscribeComponent implements OnInit {
//  channels = new Array();
  token: string;
  title = "amc-newsletter";
  customerID: string;
  private countryCode = "de";
  ipAddress = "";
  newsletterImage = "";
  cancelImage = "";
  stickImage = "";
  deButton = "";
  amcLogoImage = "";
  fieldLabel;
  fieldLabel2;
  amcContactform: FormGroup;
  amcContactformLabel: FormGroup;
  translateData = [];
  language = {key: ["de"]};
  email = "";
  httpProtocol = "";
  supplierId = "99";
  regEx = "^[a-üA-Ü -]+";
  unsub: Unsub;
  private queryParams: NavigationExtras;

  /**
   * @brief getFieldContent()
   * @param field - from the frontend form
   * @return content of a specific field
   * @details function to get the content of a specific field
   */
  getFieldContent(field) {
    return this.amcContactform.get(field);
  }

  /**
   * @brief getFieldLabel()
   * @param label - from the frontend form
   * @return translated text of the label
   * @details function to get the translated text of the label, from the database
   */
  getFieldLabel(label) {
    this.fieldLabel2 = this.amcContactformLabel.get(label);
    return this.fieldLabel2 != null ? this.fieldLabel2.value : "";
  }

  constructor(
    private router: Router,
    private registerService: RegisterService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private _platformId: Object,
    //    private channelService:ChannelService
  ) {
    this.newsletterImage = environment.newsletterImage;
    this.cancelImage = environment.cancelImage;
    this.stickImage = environment.stickImage;
    this.deButton = environment.amcLogoImage;
    this.amcLogoImage = environment.amcLogoImage;

    this.httpProtocol = environment.httpProtocol;
  }

  ngOnInit() {

    //OMU: 20250314
//**/    console.log("unsubscribe.component.ts");

    //OMU: 20250314
    if (Object.keys(this.route.snapshot.queryParams).length == 0) {
      this.router.navigate([`./${this.countryCode}/error/error`]);
    }//if

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.countryCode = params.get("lang");
    });

//    debugger;

    if (this.countryCode == null) {
      this.countryCode = "de";
    }//if

    if (this.route.snapshot.queryParams["id"]) {
      this.customerID = this.route.snapshot.queryParams["id"];
    }//if

    //OMU: 20250314
//**/    console.log(`customerID: ${this.customerID}`);

    if (this.customerID == null || this.customerID.length == 0) {
//**/    console.log(`queryParams: ${this.route.snapshot.queryParams}`);
      if (this.route.snapshot.queryParams["nl"]) {
        this.queryParams = {
          queryParams: {
            nl: this.route.snapshot.queryParams["nl"]
          }
        }
      } else if (this.route.snapshot.queryParams["service"]) {
        this.queryParams = {
          queryParams: {
            nl: this.route.snapshot.queryParams["service"]
          }
        }
      } else {
        this.router.navigate([`./${this.countryCode}/error/error`]);
      }

      this.router.navigate([`./${this.countryCode}/unsubscriber`], this.queryParams);
    }//if

    // this.channelService.getJSON().subscribe(response =>{
    //   this.channels = response.map( item =>
    //   {
    //     return new Channel(
    //       item.id,
    //       item.channel,
    //       item.service
    //     );
    //   });
    // });

    /**
     * Gets supplierId
     */
    switch (this.countryCode.toUpperCase()) {
      case "SK-SK":
        this.regEx =
          "^[a-zA-Z - Á á Ä ä Č č Ď ď É é Í í Ĺ ĺ Ľ ľ Ň ň Ó ó Ô ô Ŕ ŕ Š š Ť ť Ú ú Ý ý Ž ž]+";
        break;
      default:
        break;
    }
    this.loadTranslateDataFromDB(this.countryCode);

    /**
     * Definition of form field-labels for frontend
     */
    this.amcContactformLabel = this.formBuilder.group({
      /*
      nl_email: ["E-Mail"],
      nl_unsub_btn: ["Abmelden"],
      nl_unsub_btn_is: ["Abmelden"],
      nl_heading: ["AMC Newsletter"],
      nl_heading_ms: ["AMC Specials"],
      nl_heading_is: ["AMC Info"],
      nl_unsub: [
        "Sie möchten sich von den AMC News abmelden? Tragen Sie bitte Ihre E-Mail Adresse ein:",
      ],
      unsub: [
        "Sie möchten in Zukunft keine Informationen zu den Produkten von AMC mehr erhalten? Tragen Sie bitte Ihre E-Mail Adresse ein:",
      ],
      unsub_is: [
        "Sie möchten in Zukunft keine allgemeine Informationen von AMC erhalten? Bitte geben Sie ihre E-Mail Adresse ein:",
      ],
      nl_success_unsub: ["Sie haben sich erfolgreich abgemeldet"],
      nl_warning_mail_not_sent: [
        "Aufgrund eines Fehlers konnte keine Email verschickt werden. Bitte versuchen Sie es erneut.",
      ],
      nl_continue: ["Zurück"],
      nl_err: ["Bitte überprüfen Sie Ihre Eingabe"],
      nl_err_btn: ["Bitte überprüfen Sie Ihre Eingabe"],
      */
      n_unsub_title: ["Newsletter-Abonnement verwalten"],
      n_unsub_info: ["Schade, dass du uns verlassen möchtest. Durch die Bestätigung deiner E-Mail-Adresse " +
      "wirst du keine weiteren Updates zu unseren Produkten, " +
      "Aktionen und sonstigen AMC-Neuigkeiten erhalten. Du kannst dich auch nur von einzelnen Services abmelden."],
      n_unsub_is: ["AMC Informationen"],
      n_unsub_is_2: ["Allgemeine Informationen und Neuigkeiten von AMC."],
      n_unsub_ms: ["AMC Specials"],
      n_unsub_ms_2: ["Informationen über AMC-Dienstleistungen, Produktneuigkeiten und Promotionen."],
      n_unsub_nl: ["AMC Newsletter"],
      n_unsub_nl_2: ["Regelmäßiger AMC-Newsletter mit Produktinformationen, leckeren Rezeptideen und Tipps und Tricks."],
      n_unsub_all: ["Von allen AMC Services abmelden"],
      n_unsub_btn: ["Jetzt abmelden"],
      n_unsub_confirm_is: ["Du hast dich erfolgreich vom AMC-Informationsservice abgemeldet."],
      n_unsub_confirm_ms: ["Du hast dich erfolgreich vom AMC-Specials-Service abgemeldet."],
      n_unsub_confirm_nl: ["Du hast dich erfolgreich vom AMC-Newsletter-Service abgemeldet."],
      n_unsub_confirm_all: ["Du hast dich erfolgreich von allen AMC-Services abgemeldet."],
      n_unsub_channel: ["Kanal abmelden"],
      n_unsub_email: ["E-Mail"],
      n_unsub_post: ["Post"],
      n_unsub_phone: ["Telefon/SMS"]
    });


    /**
     * Definition of form fields for subscriber
     */
    this.amcContactform = this.formBuilder.group({
      oo_classId: ["4"],
      email: [this.customerID],
      nl: [-1],
      isNewsletter: [-1],
      medium: [""],
      token: ["inactive"],
      submittedTime: [this.getCustomDate()],
      subscriberLanguage: [this.countryCode],
      browser: [this.getBrowserInfo()],
      campaignCode: [""],
      treatmentCode: [""],
      individualHash: [""],
      countryNumber: [this.countryCode],
      supplierId: ["99"],
      active: ["1"],
      all: [false],
      allEmailChannel: [false],
      email_nl: [false],
      email_ms: [false],
      email_is: [false],
      post: [false],
      phone: [false],
    });

    this.registerService.getIPAddress().subscribe((res) => {
      this.amcContactform.patchValue({ipSubmitted: res["ip"]});
    });
  }

  isOneChecked() {
    return !!(this.getFieldContent("all").value ||
      this.getFieldContent("email_nl").value ||
      this.getFieldContent("email_is").value ||
      this.getFieldContent("post").value ||
      this.getFieldContent("phone").value);
  }

  /**
   * Submit registration data
   * 1.) Generate Email text
   * 2.) Send Data to database
   */
  onSubmit() {
    if (this.isOneChecked() && this.customerID.length) {
      this.unsub = new Unsub(
        this.customerID,
        this.getFieldContent("submittedTime").value,
        this.getFieldContent("countryNumber").value,
        this.getFieldContent("browser").value,
        this.getFieldContent("email_nl").value,
        this.getFieldContent("email_ms").value,
        this.getFieldContent("email_is").value,
        this.getFieldContent("post").value,
        this.getFieldContent("phone").value
      );

      //Set flag on false for not DE
      if(this.countryCode.toUpperCase() != 'DE'){
        this.unsub.email_nl = false;
      }

      this.registerService.unsubscribeAll(this.unsub).subscribe(
        (response) => {
          if (response["response"] == "unsubsuccess") {
            this.router.navigate(["./" + this.countryCode + "/unsubsuccess"]);
          } else {
            this.router.navigate(["./" + this.countryCode + "/error/nms"]);
          }
        },
        (error) => {
          this.router.navigate(["./" + this.countryCode + "/error/nms"]);
        }
      );
    }
  }

  /**
   * Get translated data from the database from register.service.ts
   * @param language
   */
  loadTranslateDataFromDB(language) {
    this.translateData = [];
    this.language.key = language;
    this.registerService.loadTranslateDataFromDB(this.language.key).subscribe(
      (data) => {
        this.translateData = data;
        this.setTranslate();
      },
      (error) => {
        this.router.navigate(["./" + this.countryCode + "/error/error"]);
      }
    );
  }

  /**
   * Set labels with translated texts from the database
   */
  setTranslate() {
    this.translateData.forEach((obj) => {
      this.fieldLabel = this.translateData.find((k) => k.key === obj.key);
      if (
        this.fieldLabel != null &&
        this.amcContactformLabel.get(obj.key) != null
      ) {
        this.amcContactformLabel.controls[obj.key].setValue(
          this.fieldLabel.text
        );
      }
    });
  }

  /**
   * get custom date format for database
   */
  getCustomDate(dateFormat?: any) {
    let customDatePipe = new CustomDatePipe("en-US");
    return customDatePipe.transform(new Date(), dateFormat);
  }

  /**
   * Generate a custom Token
   */
  generateCustomToken() {
    let uuid = UUID.UUID();
    const md5 = new Md5();
    return md5.appendStr(uuid).end().toString();
  }

  /**
   * get Browser Information of the subscriber
   */
  getBrowserInfo() {
    let deviceService = new DeviceDetectorService(this._platformId);
    return deviceService.browser + " V[" + deviceService.browser_version + "]";
  }

  /**
   * get URL Information of the subscriber
   */
  public getHref(bSubscribe) {
    let ret = "";
    let hostname = window.location.hostname;
    let port = window.location.port;

    if (port != "") {
      hostname = hostname + ":" + port;
    }

    ret = this.httpProtocol + hostname + "/amc-forms-web/";

    if (bSubscribe) {
      ret =
        this.httpProtocol +
        hostname +
        "/amc-forms-web/" +
        this.language.key +
        "/anmeldung?token=" +
        this.token;
    }
    return ret;
  }

  resetEmailChannelCheckBox(val: boolean) {
    this.amcContactform.patchValue({email_nl: val});
    this.amcContactform.patchValue({email_ms: val});
    this.amcContactform.patchValue({email_is: val});
  }

  checkAllEmailChannelCheckBox(ev: any) {
    if (this.getFieldContent("allEmailChannel").value) {
      this.resetEmailChannelCheckBox(true);
    } else {
      this.resetEmailChannelCheckBox(false);
    }
  }

  isAllEmailChannelCheckBoxChecked() {
    if (!this.getFieldContent("email_nl").value) return false;
    if (!this.getFieldContent("email_ms").value) return false;
    if (!this.getFieldContent("email_is").value) return false;

    return true;
  }

  resetCheckBox(val: boolean) {
    this.amcContactform.patchValue({email_nl: val});
    this.amcContactform.patchValue({email_ms: val});
    this.amcContactform.patchValue({email_is: val});
    this.amcContactform.patchValue({post: val});
    this.amcContactform.patchValue({phone: val});
  }

  checkAllCheckBox(ev: any) {
    if (this.getFieldContent("all").value) {
      this.resetCheckBox(true);
    } else {
      this.resetCheckBox(false);
    }
  }

  isAllCheckBoxChecked() {
    if (!this.getFieldContent("email_nl").value) return false;
    if (!this.getFieldContent("email_ms").value) return false;
    if (!this.getFieldContent("email_is").value) return false;
    if (!this.getFieldContent("post").value) return false;
    if (!this.getFieldContent("phone").value) return false;

    return true;
  }

  isCountryDE() {
    if (this.countryCode == null || this.countryCode.toUpperCase() == 'DE') {
      return true;
    }//if
    return false;
  }
}
